function cAdminQueue() {
    var self = this;
    $(function () { self.onload(); });
}

cAdminQueue.prototype.onload = function () {
    var self = this;
    var elQueueTable = $('#queue-table');

    elQueueTable.click(function (e) {
        self.queueTableClickHandler(e);
    });

    setTimeout(function () {
        window.location.reload();
    }, 1000 * 60);

    $(elQueueTable).dataTable({
        'paging': true,  //Table pagination
        'ordering': true,  //Column ordering
        'info': true,  //Bottom left status text
        'pageLength': 100, //Default number of items shown
        'lengthMenu': [50, 100, 200, 500, 1000],
        'order': [],
        'columnDefs': [
            { "orderable": false, "targets": 0 }
        ],
        oLanguage: {
            sSearch: 'Search all columns:',
            sLengthMenu: '_MENU_ Items per page',
            info: 'Showing page _PAGE_ of _PAGES_',
            zeroRecords: 'Nothing found - sorry',
            infoEmpty: 'No records available',
            infoFiltered: '(filtered from _MAX_ total records)'
        }
    });
}

cAdminQueue.prototype.queueTableClickHandler = function (e) {
    var target = e.target;
    var row = $(target).closest('tr').get(0);

    if ($(target).hasClass('stop')) {
        this.onQueueItemStopClick(row.getAttribute('rel'));
    }

    if ($(target).hasClass('refresh')) {
        this.onQueueItemRefreshClick(row.getAttribute('rel'));
    }
}

cAdminQueue.prototype.onQueueItemStopClick = function (item_id) {
    if (confirm('Are you sure you want to stop the processing for this item?')) {
        return this.stopQueuedItem(item_id);
    }
    return false;
}

cAdminQueue.prototype.onQueueItemRefreshClick = function (item_id) {
    if (confirm('Are you sure you want to requeue this item?')) {
        return this.refreshQueuedItem(item_id);
    }
    return false;
}

cAdminQueue.prototype.stopQueuedItem = function (job_id) {
    $.ajax({
        url: URL_ADMIN + '/items/stopjob/',
        type: 'POST',
        dataType: 'json',
        data: {
            job_id: job_id
        },
        success: function (response, statusText, xhr, el) {
            if (response.success) {
                notify.success(response.message);
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            } else {
                notify.error(response.errors[0]);
            }
        },
        error: function (jqXHR) {
            return ajaxErrorCallback(jqXHR);
        },
    });
    return false;
}

cAdminQueue.prototype.refreshQueuedItem = function (qid) {

    $.ajax({
        url: URL_ADMIN + '/items/requeue/',
        type: 'post',
        dataType: 'json',
        data: {
            qid: qid
        },
        success: function (response, statusText, xhr, el) {
            if (response.success) {
                notify.success(response.message);
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            } else {
                notify.error(response.errors[0]);
            }
        },
        error: function (jqXHR) {
            return ajaxErrorCallback(jqXHR);
        },
    });
    return false;
}
